var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modoul" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.setting.title,
            visible: _vm.setting.visible,
            width: "600",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.setting, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formModal",
                  attrs: {
                    model: _vm.formModal,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本code码", prop: "versionCode" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入版本code码" },
                        model: {
                          value: _vm.formModal.versionCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "versionCode", $$v)
                          },
                          expression: "formModal.versionCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本号", prop: "version" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入版本号" },
                        model: {
                          value: _vm.formModal.version,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "version", $$v)
                          },
                          expression: "formModal.version",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本说明", prop: "description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入版本说明",
                        },
                        model: {
                          value: _vm.formModal.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "description", $$v)
                          },
                          expression: "formModal.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "更新地址", prop: "downloadUrl" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入更新地址" },
                        model: {
                          value: _vm.formModal.downloadUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "downloadUrl", $$v)
                          },
                          expression: "formModal.downloadUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "强制更新", prop: "isForce" } },
                    [
                      _c("el-switch", {
                        on: { change: _vm.handleHotFlag },
                        model: {
                          value: _vm.formModal.isForce,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "isForce", $$v)
                          },
                          expression: "formModal.isForce",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.setting.visible = false
                      _vm.$refs.formModal.resetFields()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.settingEvent } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }